module.exports = __webpack_public_path__ + "img/youtube (2).40141a4b.svg";